
jQuery(window).on("load", function(){
     setTimeout(function(){
      $(".product_item .type-reviews .yotpo .text-m").click(function(){
		var check_subs = $(this).parents('.type-reviews').siblings('.thumbnail__caption.text-align-center').find('a').attr('href');
//             console.log(check_subs)
                  window.location.href = check_subs;
              })
   }, 2000)
})
